"use client";

import { Dispatch, SetStateAction } from "react";

import { LinkButton } from "@/components/links/LinkButton";
import { SoftText } from "@/components/text/SoftText";
import { conversionNamespace } from "@/constants/namespaces";
import { useNamedSelectedArtist } from "@/lib/zustand/useSelectedArtist";
import {
  Artist,
  ConversionConstructedNoDates,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";
import { createMixedModelName } from "@/utils/createMixedModelName";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";

export function BottomRow({
  conversion,
  artistInstrumentModelMixedModel,
  open,
  setOpen,
}: {
  conversion: ConversionConstructedNoDates;
  artistInstrumentModelMixedModel:
    | Artist
    | Instrument
    | ModelNoDates
    | MixedModelConstructedNoDates
    | null;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const isClient = useIsClient();
  // as this will only be used in conversions, we use the conversion namespace
  const useSelectedArtist = useNamedSelectedArtist((state) =>
    state.getNamedStore(conversionNamespace)
  );
  const setSelectedArtistId = useSelectedArtist(
    (state) => state.setSelectedArtistId
  );

  return (
    <div className="mt-2 flex justify-between gap-x-3">
      <SoftText elementType="p" className="truncate">
        {isClient &&
          formatDateForOutput({
            date: new Date(conversion.createdAtString),
            withTime: true,
            withYear: false,
          })}{" "}
        {artistInstrumentModelMixedModel !== null && (
          <>
            |{" "}
            <button
              type="button"
              onClick={() => setSelectedArtistId(conversion.voiceId)}
              className="inline cursor-pointer text-gray-900 transition-colors hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
              {"name" in artistInstrumentModelMixedModel ?
                artistInstrumentModelMixedModel.name
              : createMixedModelName(artistInstrumentModelMixedModel)}
            </button>
          </>
        )}{" "}
        | {conversion.name}
      </SoftText>

      <LinkButton onClick={() => setOpen((prevOpen) => !prevOpen)}>
        {open ? "Less" : "More"}
      </LinkButton>
    </div>
  );
}
